import { OrderIdsInfo } from '@cart-ui/OrderIdsInfo/OrderIdsInfo'
import { DISPLAY_STATUS_MAP } from '@constants'
import { type RefundStatus } from '@hooks-api/types/dataModel/eCommerceOrders'
import { type Transaction } from '@hooks-api/types/dataModel/fpOrder'
import { PaymentMethodMap } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { deriveDisplayStatus } from '@utils/derive-display-status'
import { useHistory } from 'react-router-dom-v5'
import { useThankyou } from '../../../fp-b2b-shared/hooks/use-thankyou'

const styles = stylex.create({
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  },
  infoBox: {
    padding: 12,
    borderRadius: 8,
    backgroundColor: colors.white,
  },
  buttonText: {
    padding: 0,
  },
})

interface OrderInfoProps {
  orderId?: string
  formatCreatedDate?: string
  purchaseOrderName?: string
  receiverName?: Transaction['receiver_name']
  childOrders?: Transaction['child_orders']
  paymentMethod?: Transaction['payment_method']
  basePath: string
  refundStatus?: RefundStatus | null
}

export const OrderInfo = ({ orderId, formatCreatedDate, purchaseOrderName, receiverName, childOrders, paymentMethod: paymentMethodProps, basePath, refundStatus }: OrderInfoProps) => {
  const history = useHistory()
  const { currency } = useThankyou()
  const handleClickToOrderDetail = () => {
    history.push(`${basePath}/my-account/order-detail/${orderId}`)
  }
  // 暫解：後端尚未回傳 display_status 時，前端根據 order status 推導
  const siblingStatuses = childOrders?.map(sibling => sibling.status)

  return (
    <VStack gap={2} padding={4} rootStyle={styles.infoBox}>
      <Text variant="subtitle">訂單資訊</Text>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>交易編號</Text>
        <Text>{orderId}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>訂單編號</Text>
        <VStack gap={1}>
          {childOrders?.map((order) => {
            const resolvedDisplayStatus = order.display_status ?? deriveDisplayStatus({
              status: order.status,
              refundStatus,
              relatedOrderStatuses: siblingStatuses,
            })
            return (
              <OrderIdsInfo
                key={order.id}
                receiverName={receiverName}
                orderId={order.order_id}
                displayStatus={DISPLAY_STATUS_MAP[resolvedDisplayStatus] || resolvedDisplayStatus}
                total={order.total}
                paymentMethod={paymentMethodProps ? PaymentMethodMap[paymentMethodProps.type] : ''}
                shippingMethodType={order.shipping_method}
                currency={currency}
              />
            )
          })}
        </VStack>
      </Box>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>訂單日期</Text>
        <Text>{formatCreatedDate}</Text>
      </Box>
      {false
      && (
        <Box rootStyle={styles.info}>
          <Text color={colors.grey600}>採購單名稱</Text>
          <Text>{purchaseOrderName}</Text>
        </Box>
      )}
      <Button variant="text" rootStyle={styles.buttonText} onClick={handleClickToOrderDetail}>
        <Text color={colors.blue600}>查看訂單詳情</Text>
      </Button>
    </VStack>
  )
}
